export const CHANGE_ORDER_STATUS = 'CHANGE_ORDER_STATUS'
export const CHANGE_ORDER_PRODUCT_STATUS = 'CHANGE_ORDER_PRODUCT_STATUS'
export const CHANGE_SELLER_ORDER_STATUS = 'CHANGE_SELLER_ORDER_STATUS'
